<template>
  <div class="container mx-auto">
    <div>
      <div class="space-y-8 mt-12">
        <!-- <section class="content">
          <h1 class="text-5xl font-extrabold">
            <span
              class="
                bg-clip-text
                text-transparent
                bg-gradient-to-r
                from-green-400
                to-blue-500
              "
            >
              Изготовление гос номеров
            </span>
          </h1>
        </section> -->

        <section class="content">
          <h1 class="sr-only">Изготовление государственных номеров на автомобили</h1>
          <img
            src="@/assets/raw-images/pages/vehicle-registration-plates/Изготовление гос.номеров with white bg.png"
            alt="Изготовление государственных номеров на автомобили - 2200 рублей, акция вместо 3000 рублей"
            class="w-full max-w-4xl mx-auto rounded-lg shadow-lg"
          />
        </section>

        <section class="content">
          <p class="tomu-info">
            <vue-feather class="icon" type="alert-triangle"></vue-feather>
            Данный раздел находится в процессе разработки. Некоторые пункты
            меню, могут не содержать <strong>полной</strong> информации!
          </p>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VehicleRegistrationPlates",
};
</script>

<style scoped></style>
